// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * The values one OPC UA node takes in the bank's adapter mapping.
 */
export class SimulationOpcUaNodeValues implements flatbuffers.IUnpackableObject<SimulationOpcUaNodeValuesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationOpcUaNodeValues {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationOpcUaNodeValues(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationOpcUaNodeValues,
  ): SimulationOpcUaNodeValues {
    return (obj || new SimulationOpcUaNodeValues()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationOpcUaNodeValues(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationOpcUaNodeValues,
  ): SimulationOpcUaNodeValues {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationOpcUaNodeValues()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  nodeId(): string;
  nodeId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  nodeId(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  values(index: number): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt64(this.bb!.__vector(this.bb_pos + offset) + index * 8) : 0n;
  }

  valuesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startSimulationOpcUaNodeValues(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addNodeId(builder: flatbuffers.Builder, nodeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeIdOffset, 0);
  }

  static addValues(builder: flatbuffers.Builder, valuesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, valuesOffset, 0);
  }

  static createValuesVector(builder: flatbuffers.Builder, data: bigint[]): flatbuffers.Offset {
    builder.startVector(8, data.length, 8);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt64(data[i]!);
    }
    return builder.endVector();
  }

  static startValuesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 8);
  }

  static endSimulationOpcUaNodeValues(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_id
    return offset;
  }

  static createSimulationOpcUaNodeValues(
    builder: flatbuffers.Builder,
    nodeIdOffset: flatbuffers.Offset,
    valuesOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SimulationOpcUaNodeValues.startSimulationOpcUaNodeValues(builder);
    SimulationOpcUaNodeValues.addNodeId(builder, nodeIdOffset);
    SimulationOpcUaNodeValues.addValues(builder, valuesOffset);
    return SimulationOpcUaNodeValues.endSimulationOpcUaNodeValues(builder);
  }

  unpack(): SimulationOpcUaNodeValuesT {
    return new SimulationOpcUaNodeValuesT(
      this.nodeId(),
      this.bb!.createScalarList<bigint>(this.values.bind(this), this.valuesLength()),
    );
  }

  unpackTo(_o: SimulationOpcUaNodeValuesT): void {
    _o.nodeId = this.nodeId();
    _o.values = this.bb!.createScalarList<bigint>(this.values.bind(this), this.valuesLength());
  }

  unpackFields(...fields: string[]): SimulationOpcUaNodeValuesT {
    const t = new SimulationOpcUaNodeValuesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_id")) {
      t.nodeId = this.nodeId();
    }
    if (fieldSet.has("values")) {
      t.values = this.bb!.createScalarList<bigint>(this.values.bind(this), this.valuesLength());
    }
    return t;
  }
}

export class SimulationOpcUaNodeValuesT implements flatbuffers.IGeneratedObject {
  constructor(
    public nodeId: string | Uint8Array | null = null,
    public values: bigint[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeId === null || this.nodeId === undefined) {
      throw new Error('Required field "node_id" is not set');
    }
    const nodeId = this.nodeId !== null ? builder.createString(this.nodeId!) : 0;
    const values = SimulationOpcUaNodeValues.createValuesVector(builder, this.values);

    return SimulationOpcUaNodeValues.createSimulationOpcUaNodeValues(builder, nodeId, values);
  }

  clone(): SimulationOpcUaNodeValuesT {
    const obj = new SimulationOpcUaNodeValuesT();
    obj.nodeId = this.nodeId;
    obj.values = [...this.values];
    return obj;
  }

  equals(other: SimulationOpcUaNodeValuesT): boolean {
    if (this.nodeId !== other.nodeId) return false;
    if (this.values.length !== other.values.length) return false;
    for (let i = 0; i < this.values.length; i++) {
      if (this.values[i] !== other.values[i]) return false;
    }
    return true;
  }
}

export function verifySimulationOpcUaNodeValues(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVector(pos, 8);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
